import Vue from "vue";
import Vuex from "vuex";
import token from "./token";
import app from "./app";
import { getQueryString } from "@/utils";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    /**
     * 活动配置数据
     * @param download_url 下载地址
     */
    config: {},
    /**
     * 用户基本信息
     */
    user: null,
    /** 当前标签 1-回归福利 2-限定大奖 */
    activeTab: 2,
    /** 服务端时间戳 */
    serverTime: null
  },
  getters: {
    // 是否debug
    isDebug: () => process.env.VUE_APP_DEBUG === "true",
    // 活动功能配置
    abilities: state => state.config.ability_list || {},
    // 下载地址
    donwloadUrl: state => state.config.download_url,
    // 用户数据
    user: state => state.user,
    // 邀请码
    inviteCode: state => state.user && state.user.user_sign,
    // 判断是否渠道页
    isChannel: () => {
      return getQueryString("referrer") === "channel";
    },
    // 当前标签
    activeTab: state => state.activeTab,
    // 服务端时间戳
    serverTime: state => state.serverTime
  },
  mutations: {
    // 设置活动配置数据
    SET_CONFIG(state, data) {
      state.config = data;
    },
    // 设置用户基本信息
    SET_USER(state, data) {
      state.user = data;
    },
    // 设置当前标签
    SET_ACTIVE_TAB(state, data) {
      state.activeTab = data;
    },
    // 设置服务端时间戳
    SET_SERVER_TIME(state, data) {
      state.serverTime = data;
    }
  },
  actions: {
    // 设置活动配置数据
    setConfig(context, data) {
      context.commit("SET_CONFIG", data);
    },
    // 设置用户基本信息
    setUser(context, data) {
      context.commit("SET_USER", data);
    },
    // 设置当前标签
    setActiveTab(context, data) {
      context.commit("SET_ACTIVE_TAB", data);
    },
    // 设置服务端时间戳
    setServerTime(context, data) {
      context.commit("SET_SERVER_TIME", data);
    }
  },
  modules: { token, app }
});
